// CountUp Dependency
import { CountUp } from 'countup.js';

export default function() {
  const stats = document.querySelectorAll('.stat__value');

  if(stats) {

    const observerConfig = {
      rootMargin: '-12.5% 0% -12.5% 0%',
      threshold: [0.25, 0.5, 0.66]
    };

    stats.forEach((stat)=> {
      const thisValue = stat.textContent;
      const thisDelay = stat.dataset.delay;

      const thisCounter = new CountUp(stat, thisValue, {duration: 1.5});

      const observer = new IntersectionObserver( function(entries) {
        entries.forEach(function(entry) {
          const thisTarget = entry.target;
          const inView = thisTarget.classList.contains('in-view');
          if (entry.intersectionRatio > 0) {
            setTimeout(function(){
              // console.log('yo');
              thisCounter.start();
            }, thisDelay);
            observer.unobserve(thisTarget);
          }
        });
      }, observerConfig);

      observer.observe(stat);
    });
  }
}
